import config from '../Config';
import 'whatwg-fetch';
import {
  authHeader
}
from '../utils/auth-header';
import md5 from 'md5';

export const dealerService = {
  loadConfig, recordContactEmail, confirmContactEmail,
  confirmRequest, loadRewacoInfo
};


async function loadConfig() {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(
    `${config.configpath}contact.txt`,
    requestOptions).then(
    handleResponse);
}

async function loadRewacoInfo(lang) {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(
    `${config.configpath}rwinfo_${lang}.txt`,
    requestOptions).then(
    handleResponse);
}

/*
# User Vehicle Request Email
*/

async function recordContactEmail(email, lang) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': md5(config.masterpassword + email),
    },
    body: JSON.stringify({
      email: email,
      lang: lang
    })
  };

  return fetch(
    `${config.protocol}://${config.apihost}/vehiclerequest/record`,
    requestOptions).then(
    handleResponse);
}



async function confirmContactEmail(requestid) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': md5(config.masterpassword + requestid),
    },
    body: JSON.stringify({
      requestid: requestid
    })
  };

  return fetch(
    `${config.protocol}://${config.apihost}/vehiclerequest/confirm`,
    requestOptions).then(
    handleResponse);
}

async function confirmRequest(requestid) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': md5(config.masterpassword + requestid),
    },
    body: JSON.stringify({
      requestid: requestid
    })
  };

  return fetch(
    `${config.protocol}://${config.apihost}/vehiclerequest/confirm`,
    requestOptions).then(
    handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        //logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
